/**
 * Identity tuple encoding for the `/alarms?alarm=<identity>` deep-link
 * (EPIC #225 sub 7/10, spec §6.4). Alarm identity is the tuple
 * (site_id, device_id, condition_key) — the same canonical identity used
 * across the Phase 2 reconciler, Phase 3 API, and Phase 4 WS.
 *
 * Encoding: colon-joined. The condition_key may contain dots
 * (e.g. `bms.evt.ground_fault`) but never colons in production. The decoder
 * rejoins the tail defensively in case future keys ever do.
 */

export interface AlarmIdentity {
  siteId: string;
  deviceId: string;
  conditionKey: string;
}

const SEP = ':';

export function encodeAlarmIdentity(id: AlarmIdentity): string {
  return `${id.siteId}${SEP}${id.deviceId}${SEP}${id.conditionKey}`;
}

export function decodeAlarmIdentity(s: string | null | undefined): AlarmIdentity | null {
  if (!s) return null;
  const parts = s.split(SEP);
  if (parts.length < 3) return null;
  const [siteId, deviceId, ...rest] = parts;
  if (!siteId || !deviceId || rest.length === 0 || rest.every((p) => p.length === 0)) {
    return null;
  }
  return { siteId, deviceId, conditionKey: rest.join(SEP) };
}
